import React from 'react';

import { Icon } from '@upgrade/react-components';
import { mdiCheck } from '@mdi/js';
import { IconContainer, Item } from './styles';
import { Text } from '../TypographyPublicSite';
import { toHtmlSanitize } from '../../../utils/remark-html';

const Highlight = ({
  color = 'contentWeak',
  icon = mdiCheck,
  iconBackgroundColor,
  iconColor,
  iconSize = '1.5rem',
  justify = 'start',
  superscript,
  text,
  textAlign = 'left',
  textSize = 'sm'
}) => {
  return (
    <Item iconBackgroundColor={iconBackgroundColor} {...{ justify }}>
      <IconContainer iconBackgroundColor={iconBackgroundColor}>
        <Icon color={iconColor || 'actionablePrimary'} size={iconSize} icon={icon} />
      </IconContainer>
      <Text
        size={textSize}
        color={color}
        align={textAlign}
        dangerouslySetInnerHTML={{ __html: toHtmlSanitize(text, { removeWrappingPTag: true }).trim() }}
      />
      {superscript && (
        <Text color={color}>
          <sup>{superscript}</sup>
        </Text>
      )}
    </Item>
  );
};

export default Highlight;
